'use strict';

angular.module('internal.inspections')
    .controller('InternalInspectionDeficiencyCategoryModal', ['$scope', '$uibModalInstance', 'IPDeficiencyCategories', function ($scope, $uibModalInstance, IPDeficiencyCategories) {
        $scope.deficiency_category = {};
        $scope.saving = false;

        $scope.save = function () {
            $scope.saving = true;
            IPDeficiencyCategories.save($scope.deficiency_category).then(function (newCategory) {
                $scope.saving = false;
                $uibModalInstance.close(newCategory);
            })
        }

        $scope.close = function () {
            $uibModalInstance.dismiss('cancel');
        }
    }])
;